import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "hotel-description-grid__left" }
const _hoisted_2 = { class: "hotel-description-grid__right" }

import { descriptionToItemProps } from '@lmt-rpb/HotelDescriptionItem/helpers';
import { computed } from 'vue';
import HotelDescriptionItem from '@lmt-rpb/HotelDescriptionItem/HotelDescriptionItem.vue';
import HotelInfoDisclaimer from '@lmt-rpb/Atoms/HotelInfoDisclaimer/HotelInfoDisclaimer.vue';
import type { Description } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';
import { chunkArray } from '@/js/utils/arrayUtils';

interface Props {
	descriptions: Description[];
	columnDirection?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HotelDescriptionGrid',
  props: {
    descriptions: { default: () => [] },
    columnDirection: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const hotelDescriptionClasses = computed(() => ({
	'hotel-description-grid--column': props.columnDirection,
}));

const hasMoreThanOneElement = computed(() => props.descriptions.length > 1);

const mappedDescriptions = computed(() => props.descriptions.map((description) => descriptionToItemProps(description)));
const chunks = computed(() => chunkArray(mappedDescriptions.value, 2));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['hotel-description-grid', hotelDescriptionClasses.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunks.value.at(0), (description) => {
        return (_openBlock(), _createBlock(HotelDescriptionItem, _mergeProps({
          key: description.title,
          ref_for: true
        }, description), null, 16 /* FULL_PROPS */))
      }), 128 /* KEYED_FRAGMENT */)),
      (!hasMoreThanOneElement.value)
        ? (_openBlock(), _createBlock(HotelInfoDisclaimer, { key: 0 }))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunks.value.at(1), (description) => {
        return (_openBlock(), _createBlock(HotelDescriptionItem, _mergeProps({
          key: description.title,
          ref_for: true
        }, description), null, 16 /* FULL_PROPS */))
      }), 128 /* KEYED_FRAGMENT */)),
      (hasMoreThanOneElement.value)
        ? (_openBlock(), _createBlock(HotelInfoDisclaimer, { key: 0 }))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}
}

})